/**
 * Return true if the string autorizes html.
 */
export function isStringAuthorizeHtml(str) {
  return /^\[HTML\]/.test(str) && /\[\/HTML\]$/.test(str);
}

/**
 * Wrap string into a pattern that indicates that we authorize HTML in that string.
 * Used by `ErrorMessage` component.
 */
// $FlowFixMe[unclear-type]
export function authorizeHtml(str) {
  if (typeof str === 'string') {
    return `[HTML]${str}[/HTML]`;
  }

  // $FlowFixMe[unclear-type]
  function authorizeHtmlInObject(obj) {
    return Object.keys(obj).reduce((acc, key) => ({
      ...acc,
      [key]: authorizeHtml(obj[key])
    }), {});
  }
  return authorizeHtmlInObject(str);
}

/**
 * Remove pattern to retrieve the original string(s).
 */
// $FlowFixMe[unclear-type]
export function unprotectAuthorizedHtml(str) {
  if (typeof str === 'string') {
    return str.replace('[HTML]', '').replace('[/HTML]', '');
  }

  // $FlowFixMe[unclear-type]
  function unprotectAuthorizedHtmlInObject(obj) {
    return Object.keys(obj).reduce((acc, key) => ({
      ...acc,
      [key]: unprotectAuthorizedHtml(obj[key])
    }), {});
  }
  return unprotectAuthorizedHtmlInObject(str);
}